import {Box, Typography} from "@mui/material";
import Button from "@mui/material/Button";
import {Container, Row, Col, Modal} from 'react-bootstrap';
import React, {useEffect, useState} from "react";
import t from "../../../Utils/Translation";
import LykioButton from "../../common/LykioButton";
import {Viewer, Worker} from "@react-pdf-viewer/core";
import {defaultLayoutPlugin} from "@react-pdf-viewer/default-layout";
import {styled} from "@mui/material/styles";
import {startActivitySession} from "../../../Utils/TimerUtils";

const LykioCustomButton = styled(Button)(() => ({
    background: "linear-gradient(to bottom, #006f4b, #006f4b)",
    color: "white",
    borderColor: "#c4c5c7",
    '&:hover': {
        background: "white",
        color: "#006f4b",
        borderStyle: 'solid !important',
        borderWidth: '0.2em',
        borderRadius: '7px',
        borderColor: "#006f4b"
    },
}));
const Start = (props) => {

    const [modal, setModal] = useState(null);
    const handleOpen = (id) => {
        setModal(id);
    };

    const handleClose = () => {
        setModal(null);
    };

    const transform = (slot) => ({
        ...slot,
        // These slots will be empty
        Open: () => <></>
    });


    const renderToolbar = (Toolbar) => (
        <Toolbar>{renderDefaultToolbar(transform)}</Toolbar>
    )
    const defaultLayoutPluginInstance = defaultLayoutPlugin({renderToolbar,});

    const {renderDefaultToolbar} = defaultLayoutPluginInstance.toolbarPluginInstance


    const handleStart = () => {
        startActivitySession(props.testId)
        props.handleNextStep()
    }

    return (
        <div className="lykiocss-margin-top-4em">
        <Row className="lykiocss-center" style={{marginBottom:'2em'}}>
            <div style={{background: "linear-gradient(to bottom, #006f4b, #006f4b)",textAlign:'center', color: 'white', padding: '1em', fontSize:'21px', borderRadius:'0.3em', maxWidth:'24em'}} className="lykiocss-center">
                {t('EVALUATE THREE CANDIDATES BASED ON THEIR PRESENTATIONS AND CV')}
            </div>
        </Row>
    
        <Row className="lykiocss-center">
        <Box
            bgcolor="#098b43"
            color="white"
            borderRadius={3}
            p={3}
            m={2}
            textAlign={'center'}
            justifyContent="center"
            alignItems="center"
            style={{maxWidth:'60em', background: "linear-gradient(to bottom, #006f4b, #006f4b)"}}
        >
        <Container>
            <Row>
                <Col>
                <p style={{fontSize:'21px'}}>{t("You are currently involved in the selection process for a Junior R&D Fermentation profile, which you can find the announcement for on the side. After conducting CV screenings, three candidates have been identified as being suitable for the position in terms of technical skills and professional profile. These three candidates have been asked to present themselves in a 1-minute video each. Your task is to evaluate which candidate demonstrates the most reability and orientation towards intercultural team working, both of which are essential skills for the role. Please be mindful not to be influenced by any prejudices or biases that may arise. Based on your assessment, which of the three candidates would you choose to call for an interview?")}
</p>
                </Col>
                <Col>
                <div style={{border: '0px solid #0b6190', cursor: 'pointer'}} onClick={() => handleOpen(1)}>
                    <p style={{marginLeft:'0em'}}>{t('Job announcement')}</p>
                    <img src="https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/annuncio_val1.png" alt="image1" className="img-fluid" style={{width:'60%'}}/>
                </div>
                </Col>
            </Row>
        </Container>
        
        </Box>
        </Row>
        
        <Row className="lykiocss-center">
              <LykioCustomButton style={{maxWidth:'20em', fontSize: '21px', padding:'0.5em', paddingLeft:'2em', paddingRight:'2em'}} className="lykiocss-margin-top-2em" onClick={handleStart}>{t('Start')}</LykioCustomButton>
        </Row>
        {modal === 1 && (
                <Modal show={true} onHide={handleClose} size='xl' >
                    <Modal.Header closeButton>
                        <Modal.Title>{t('Job announcement')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Box height={'70vh'} position={'relative'}>
                            <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.1.81/build/pdf.worker.min.js">
                                <div   style={{
                                    height: '100%',
                                    width: '100%'
                                }}>
                                    <Viewer fileUrl={localStorage.getItem("i18n")==="it" ? "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/Videos+for+Comparative+Evaluation+Activity/Annuncio+IRC217703+VALUTAZIONE.pdf": "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/Job+announcement_JuniorR%26DFermentation+(VALUTAZIONE)+ENG.pdf"} plugins={[defaultLayoutPluginInstance]} />;
                                </div>
                            </Worker>
                        </Box>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            {t("Close")}
                        </Button>
                    </Modal.Footer>
                </Modal>

            )}
        </div>
    );

}

export default Start;